import { logErrorToFirestore } from "../firebase";

const originalConsoleLog = console.log;
const originalConsoleInfo = console.info;
const originalConsoleDebug = console.debug;
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

const ignorePatterns = [
  /@firebase\/firestore/,
  /WebChannelConnection/,
  /PersistentStream/,
  /A component is `contentEditable` and contains `children` managed by React/,

  // XYFlow/ReactFlow benign warnings that can spam during interactions.
  /Parent node .* not found\. Please make sure that parent nodes are in front of their child nodes/,
  /Please make sure that parent nodes are in front of their child nodes/,
];

const stringifyFirstArg = (args: unknown[]): string => {
  const first = args[0];
  if (first instanceof Error) {
    return first.stack || first.message || String(first);
  }
  return String(first);
};

const shouldIgnore = (args: unknown[]) => {
  const message = stringifyFirstArg(args);
  return ignorePatterns.some((pattern) => pattern.test(message));
};

const isDebugLoggingEnabled = (() => {
  try {
    // Default: keep dev console quiet; opt-in when needed.
    if (!import.meta.env.DEV) return false;
    const value = localStorage.getItem("focusmap:debugLogs");
    return value === "1" || value === "true";
  } catch {
    return false;
  }
})();

console.log = (...args) => {
  if (!isDebugLoggingEnabled) return;
  if (!shouldIgnore(args)) originalConsoleLog(...args);
};

console.info = (...args) => {
  if (!isDebugLoggingEnabled) return;
  if (!shouldIgnore(args)) originalConsoleInfo(...args);
};

console.debug = (...args) => {
  if (!isDebugLoggingEnabled) return;
  if (!shouldIgnore(args)) originalConsoleDebug(...args);
};

console.warn = (...args) => {
  if (!shouldIgnore(args)) originalConsoleWarn(...args);
};

console.error = (...args) => {
  if (shouldIgnore(args)) return;

  originalConsoleError(...args);

  const errorMessagesToIgnore = [
    "Warning: You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.",
    "Error while reading CSS rules from https://fonts.googleapis.com",
    "Error loading remote stylesheet",
    "Error inlining remote css file",
  ];

  const message = stringifyFirstArg(args);
  if (errorMessagesToIgnore.some((msg) => message.includes(msg))) {
    return;
  }

  // Fire-and-forget to avoid blocking the UI thread.
  void logErrorToFirestore(message);
};

export {};
